import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import * as d3 from 'd3';
import { max } from 'lodash';
@Component({
    selector: 'app-combo-chart',
    templateUrl: './combo-chart.component.html'
})
export class ComboChartComponent implements OnInit {
    @Input() GraphData: any;
    viewData = [];
    barnumber = 4;
    currentPage = 1;
    totalPage: number;
    constructor() { }
    ngOnInit(): void {
    }
    ngAfterViewInit() {
        this.LoadComboChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }
    LoadComboChart(comboData, chartContainer) {
        let that = this;
        d3.select(chartContainer).html("");
        let chartContainerwithoutHash = chartContainer.split('#')[1];
        //console.log(lineData);
        this.totalPage = Math.ceil(comboData.length / this.barnumber);
        this.viewData = comboData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
        // set the dimensions and margins of the graph
        var svgWidth = d3.select(chartContainer).node().offsetWidth, svgHeight = 350;
        var margin = { top: 20, right: 65, bottom: 90, left: 75 };
        var width = svgWidth - margin.left - margin.right;
        var height = svgHeight - margin.top - margin.bottom;
        const xscale_bw = 30;
        const rx = xscale_bw / 2, ry = xscale_bw / 2;
        var svg = d3.select(chartContainer).append("svg")
            .attr("width", svgWidth)
            .attr("height", svgHeight)
            .attr("preserveAspectRatio", "xMinYMin meet")
        // .attr("viewBox", "0 0 " + svgWidth + " " + svgHeight);
        svg.append("defs").append("clipPath")
            .attr("id", chartContainerwithoutHash + "_clip")
            .append("rect")
            .attr("width", width)
            .attr("height", height);
        //Create group element inside svg element to draw chart
        const chart = svg.append('g')
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")"
            );
        let maxDataY1 = d3.max(comboData, function (d) {
            return parseInt(d.sankeyY1Data);
        });
        var y1Range = d3.scaleLinear().range([height, 0]);
        var y1Scale = y1Range.domain([0, maxDataY1]);

        //var tickY1Axis = (Math.round((Math.round(Math.round(d3.max(this.viewData, function (d) { return parseInt(d.sankeyY1Data); }) / 5) / 10) * 10) / 50) * 50) + 50;
        let y1Ticks = that.GenerateTicks(y1Range, maxDataY1);
        maxDataY1 = y1Ticks[y1Ticks.length - 1];
        y1Scale = y1Range.domain([0, maxDataY1]);
        var y1Axis = chart.append('g').attr("class", "y1axis yaxis").call(d3.axisLeft(y1Scale)
            .tickFormat(d => {
                return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
            })
            //.tickFormat(function (x) { return (that.viewData[0].XAxis != "TicketCount" ? (x >= 1000 ? ((x / 1000).toFixed(1) + 'k') : x) : x) })
            .tickSize(-width)
            .tickPadding(10)
            .tickValues(that.GenerateTicks(y1Range, maxDataY1)));

        y1Axis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        y1Axis
            .select('.domain')
            .style('opacity', 0);
        var xScale = d3.scaleBand().range([0, width]).domain(this.viewData.map((d) => d.sankeyXData)).round(true).padding(0.36);

        var xAxis = chart.append('g')
            .attr('transform', `translate(0, ${height})`)
            .attr("class", "xaxis")
            .call(d3.axisBottom(xScale).tickPadding(5).tickSize(10, 10));
        xAxis
            .selectAll('line')
            .attr('stroke', '#e6e6e6')
        xAxis
            .select('.domain')
            .style('opacity', 0);
        //Show the x axis labels in 45 degree and show only alternate labels in case if more than 20 x axis labels are there
        d3.select(chartContainer).selectAll('.xaxis text')
            .attr("x", 0)
            //.style("text-anchor", lineData.length > 6 ? "end" : "")
            .style("text-anchor", "middle")
            .attr('class', function (d, i) { if (that.viewData.length > 20 && i % 2 != 0) { d3.select(this).remove(); } })
            //.attr("transform", lineData.length > 6 ? "rotate(-45)" : "");
            //.attr("transform", "rotate(-45)")
            .text(d => {
                if (d.length > 12) {
                    d = d.substring(0, 9) + '...';
                }
                return d;
            })
            .append('title')
            .text(d => d); //d.length > 12 ? d : null);
        let maxDataY2 = d3.max(comboData, function (d) {
            return parseInt(d.sankeyY2Data);
        });
        //Y2 scale for line chart
        var y2Range = d3.scaleLinear().range([height, 0]);
        var y2Scale = y2Range.domain([0, maxDataY2]);
        //var tickY2Axis = (Math.round((Math.round(Math.round(d3.max(this.viewData, function (d) { return parseInt(d.sankeyY2Data); }) / (d3.select('.y1axis').selectAll('.tick').nodes().length)) / 10) * 10) / 50) * 50) + 500;
        //var tickY2Axis = d3.max(comboData, function (d) { return parseInt(d.sankeyY2Data); }) / (d3.select('.y1axis').selectAll('.tick').nodes().length);
        let y2Ticks = that.GenerateTicks(y2Range, maxDataY2);
        maxDataY2 = y2Ticks[y2Ticks.length - 1];
        y2Scale = y2Range.domain([0, maxDataY2]);
        var y2Axis = chart.append('g')
            .attr("transform", "translate( " + width + ", 0 )")
            .attr("class", "y2axis yaxis")
            .call(d3.axisRight(y2Scale)
                .tickFormat(d => {
                    return (d > 1 || d == 0) ? `${d3.format("~s")(d)}` : d.toFixed(1);
                })
                //.tickFormat(function (x) { return (this.viewData[0].XAxis == "TicketCount" ? (x >= 1000 ? ((x / 1000).toFixed(1) + 'k') : x) : x) })
                //.tickSize(0)
                .tickPadding(10)
                .tickValues(that.GenerateTicks(y2Range, maxDataY2)));
        y2Axis
            .selectAll('line')
            .attr('opacity', 0)
        y2Axis
            .select('.domain')
            .style('opacity', 0);
        d3.select(chartContainer).selectAll('.y2axis text')
            .style('text-anchor', 'start');

        ////To find the tick transformation of Y1 axis ticks and assign to corresponding ticks in Y2 axis ticks
        //var ticksTransform = [];
        //y1Ticks = d3.select(chartContainer).selectAll('.y1axis .tick');
        //y1Ticks.each(function (d, i) { ticksTransform[i] = d3.select(this).attr("transform") });
        //d3.select(chartContainer).selectAll('.y2axis .tick').each(function (d, i) { d3.select(this).attr("transform", ticksTransform[i]) });

        var xLine = d3.scalePoint()
            .range([0, width])
            .domain(this.viewData.map((d) => d.sankeyXData))
            .padding(0.75);

        //Hide the x axis ticks if alternate labels are shown when more than 20 labels
        // d3.select(chartContainer).selectAll('.xaxis ticks')
        //     .attr("class", function (d, i) { if (this.viewData.length > 20 && i % 2 != 0) { d3.select(this).remove(); } });

        // //Tooltip
        // var tooltip = d3.select(chartContainer)
        //     .append("div")
        //     .attr("class", "tooltip")
        //     .style("opacity", 0)
        //     .style('border-color', '#0170bf');

        //Drawing Column chart
        var barGroups = chart
            .append('g')
            .attr("clip-path", "url(#" + chartContainerwithoutHash + "_clip)")
            .selectAll()
            .data(this.viewData)
            .enter()
        // .append('rect')
        // .attr('x', function (s) { return xScale(s.sankeyXData); })
        // .attr('y', function (s) { return y1Scale(s.sankeyY1Data); })
        // .attr('height', function (s) { return height - y1Scale(s.sankeyY1Data); })
        // .attr('width', xScale.bandwidth())
        var columns = barGroups.append('path')
            //.attr('class', 'bar mainBars')
            .attr("d", d => `M${xScale(d.sankeyXData) + xScale.bandwidth() / 2 - (xscale_bw / 2)},${y1Scale(d.sankeyY1Data) + ry}
			a${rx},${ry} 0 0 1 ${rx},${-ry}
			h${xscale_bw - 2 * rx}
			a${rx},${ry} 0 0 1 ${rx},${ry}
			v${height - y1Scale(d.sankeyY1Data) - ry}
			h${-(xscale_bw)}Z
			`)
            .attr("fill", "#41B6FF")
            .attr("class", "combobar");
        chart
            .append('g')
            .selectAll()
            .data(this.viewData)
            .enter()
            .append("text")
            .attr("text-anchor", "middle")
            .attr("y", d => y1Scale(d.sankeyY1Data) - 5)
            .attr("x", (d, i) => xScale(d.sankeyXData) + xScale.bandwidth() / 2 - rx + 14)
            .attr("font-size", "8px")
            .style("fill", "black")
            .attr("font-family", "Graphik SemiBold")
            .text((d, i) => {
                return that.CleanNumber(parseInt(d.sankeyY1Data));
            });
        columns.on('mouseover', function (d, i) {
            //console.log(d);
            //console.log(d3.select(this.parentNode).datum().key)
            d3.select(this).style("fill", "#0096f4");
            d3.select(this).style('cursor', 'pointer');
            var tooltip = svg
                .append("g")
                .style("cursor", "pointer")
                .attr("class", "tooltip")
                .style("opacity", 1)
            tooltip.append("rect")
                .attr("width", 90)
                .attr('height', 40)
                .style('fill', '#FFFFFF')
                .style('pointer-events', 'none')
                .style('stroke', d3.select(this).style('fill'))
                .style('stroke-width', 2)
                .style('fill-opacity', 0.8);
            var textSvg = tooltip.append("text")
                .attr('x', 7)
                .attr('y', 15)
                .style('pointer-events', 'none')
                .style('fill', '#333333')
                .style('font-size', '12px')
                .style('color', '#333333');
            textSvg.append("tspan")
                .style('font-size', '11px')
                .style('pointer-events', 'none')
                .style('font-family', 'Graphik Regular')
                .style('font-weight', 'bold')
                .text(d3.select(this).data()[0].sankeyXData)
            textSvg.append("tspan")
                .attr('x', 7)
                .attr('dy', 15)
                .style('pointer-events', 'none')
                .style('fill', d3.select(this).style('fill'))
                .html('&#x25cf') //&#9679; //&bull;
            textSvg.append("tspan")
                .attr('dx', 0)
                .style('pointer-events', 'none')
                .style('font-size', '11px')
                .style('font-family', 'Graphik Regular')
                .style('font-weight', 'bold')
                .text(that.viewData[0].XAxis == "TicketCount" ? "TicketAge: " : "#Tickets: ")
                .style('font-weight', 'bold')
            textSvg.append("tspan")
                .attr('dx', 0)
                .style('pointer-events', 'none')
                .style('font-family', 'Graphik Regular')
                .style('font-weight', 'bold')
                .text(d3.format(',')(parseInt(d3.select(this).data()[0].sankeyY1Data)) + ' ' + ((that.viewData[0].XAxis == "TicketCount" ? "TicketAge" : "#Tickets") == 'TicketAge' ? 'Days' : ''));
        })
            .on("mousemove", function (d, i) {
                //d3.select(this).style('opacity', 1)
                d3.select(this).style("fill", "#0096f4");
                d3.select(this).style('cursor', 'pointer');
                var mousePosition = d3.mouse(this);
                var x = mousePosition[0];// + width / 2;
                var y = mousePosition[1];// + height / 2;
                var text = d3.select(this.closest('svg')).select('.tooltip text');
                //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
                //    console.log(element.getBBox().width);
                //})
                var bbox = text.node().getBBox();
                d3.select(this.closest('svg'))
                    .select('.tooltip rect')
                    .attr("width", bbox.width + 15)
                if (x - bbox.width / 2 < 0) {
                    x = bbox.width / 2;
                }
                else if (width - x - bbox.width / 2 < 0) {
                    x = width - bbox.width / 2;
                }
                if (y - bbox.height / 2 < 0) {
                    y = bbox.height * 2;
                }
                else if (height - y - bbox.height / 2 < 0) {
                    y = height - bbox.height / 2;
                }
                d3.select(this.closest('svg'))
                    .select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${x + 10}, ${y - 20})`);
            })
            .on("mouseout", function (d, i) {
                d3.select(this).style("fill", "#41B6FF");
                d3.select(this.closest('svg'))
                    .select('.tooltip').style('display', 'none');
                d3.select(this.closest('svg'))
                    .select(".tooltip").remove();
                d3.select(this)//.selectAll('path')
                    .style("opacity", 1);
            });

        // define the line
        var comboLine = d3.line()
            .x(function (d) { return xLine(d.sankeyXData); }) // set the x values for the line generator
            .y(function (d) { return y2Scale(d.sankeyY2Data); }) // set the y values for the line generator 
            .curve(d3.curveCatmullRom.alpha(1));
        //Binds data to the line 
        chart.append('g')
            .append("path")
            .datum(this.viewData)
            .attr('class', 'line')
            .attr("fill", "none")
            .attr("stroke", "#02209A")
            .attr("opacity", "0.7")
            .attr("stroke-width", 3)
            .attr('d', comboLine);
        //append text for each data point
        chart
            .selectAll(".linetext")
            .data(this.viewData)
            .enter().append("text") // Uses the enter().append() method
            .attr("class", "linetext") // Assign a class for styling
            .attr("x", function (d) { return xLine(d.sankeyXData) + 10 })
            .attr("y", function (d) { return y2Scale(d.sankeyY2Data) - 1 })
            .attr('fill', '#000')
            .style('font-size', '10px')
            .text(d => that.CleanNumber(d.sankeyY2Data))
        //append dots in line for each data to hover
        chart
            .selectAll(".dot")
            .data(this.viewData)
            .enter().append("circle") // Uses the enter().append() method
            .attr("class", "dot") // Assign a class for styling
            .attr("cx", function (d) { return xLine(d.sankeyXData) })
            .attr("cy", function (d) { return y2Scale(d.sankeyY2Data) })
            .attr("r", 5)
            .attr("fill", "white")
            .attr('stroke', '#02209A')
            .attr("stroke-width", "1")
            .attr("z-index", 99)
            .on('mouseover', function (actual, i) {
                chart
                    .append("circle")
                    .attr("r", 6)
                    .attr("class", "dot")
                    .attr('id', 'dotFocus')
                    .attr("cx", xLine(d3.select(this).data()[0].sankeyXData))
                    .attr("cy", y2Scale(parseInt(d3.select(this).data()[0].sankeyY2Data)))
                    .attr("fill", "white")
                    .attr('stroke', '#02209A')
                    .attr("stroke-width", "1")
                    .style('pointer-events', 'none')
                    .style('opacity', 0.7);

                // d3.select(this).attr("r", 5);
                // d3.select(this).style("stroke", '#ffffff');
                // d3.select(this).style('stroke-width', 1);

                d3.select(this).style('cursor', 'pointer');
                var tooltip = svg
                    .append("g")
                    .style("cursor", "pointer")
                    .attr("class", "tooltip")
                    .style("opacity", 1)
                tooltip.append("rect")
                    .attr("width", 90)
                    .attr('height', 40)
                    .style('fill', '#FFFFFF')
                    .style('pointer-events', 'none')
                    .style('stroke', '#02209A')//d3.select(this).style('fill'))
                    .style('stroke-width', 2)
                    .style('fill-opacity', 0.8);
                var textSvg = tooltip.append("text")
                    .attr('x', 7)
                    .attr('y', 15)
                    .style('pointer-events', 'none')
                    .style('fill', '#333333')
                    .style('font-size', '12px')
                    .style('color', '#333333');
                textSvg.append("tspan")
                    .style('font-size', '11px')
                    .style('pointer-events', 'none')
                    .style('font-family', 'Graphik Regular')
                    .style('font-weight', 'bold')
                    .text(d3.select(this).data()[0].sankeyXData)
                textSvg.append("tspan")
                    .attr('x', 7)
                    .attr('dy', 15)
                    .style('pointer-events', 'none')
                    .style('fill', '#02209A')//d3.select(this).style('fill'))
                    .html('&#x25cf') //&#9679; //&bull;
                textSvg.append("tspan")
                    .attr('dx', 0)
                    .style('pointer-events', 'none')
                    .style('font-size', '11px')
                    .style('font-family', 'Graphik Regular')
                    .style('font-weight', 'bold')
                    .text(that.viewData[0].XAxis == "TicketCount" ? "#Tickets: " : "TicketAge: ")
                    .style('font-weight', 'bold')
                textSvg.append("tspan")
                    .attr('dx', 0)
                    .style('pointer-events', 'none')
                    .style('font-family', 'Graphik Regular')
                    .style('font-weight', 'bold')
                    .text(d3.format(',')(parseInt(d3.select(this).data()[0].sankeyY2Data)) + ' ' + ((that.viewData[0].XAxis == "TicketCount" ? "#Tickets" : "TicketAge") == 'TicketAge' ? 'Days' : ''));
            })
            .on("mousemove", function (d, i) {
                //d3.select(this).style('opacity', 1)
                d3.select(this).style("opacity", 0.7);
                d3.select(this).style('cursor', 'pointer');
                var mousePosition = d3.mouse(this);
                var x = mousePosition[0];// + width / 2;
                var y = mousePosition[1];// + height / 2;
                var text = d3.select(this.closest('svg')).select('.tooltip text');
                //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
                //    console.log(element.getBBox().width);
                //})
                var bbox = text.node().getBBox();
                d3.select(this.closest('svg'))
                    .select('.tooltip rect')
                    .attr("width", bbox.width + 15)
                if (x - bbox.width / 2 < 0) {
                    x = bbox.width / 2;
                }
                else if (width - x - bbox.width / 2 < 0) {
                    x = width - bbox.width / 2;
                }
                if (y - bbox.height / 2 < 0) {
                    y = bbox.height * 2;
                }
                else if (height - y - bbox.height / 2 < 0) {
                    y = height - bbox.height / 2;
                }
                d3.select(this.closest('svg'))
                    .select('.tooltip')
                    .style("opacity", 1)
                    .attr('transform', `translate(${x + 10}, ${y - 20})`);
            })
            .on("mouseout", function (actual, i) {
                d3.select(this).attr("r", 5)
                    .attr("fill", "white")
                    .attr('stroke', '#02209A')
                    .attr("stroke-width", "1")
                d3.select(this).style('opacity', 1);
                //hide tooltip
                //d3.select(this).style("fill", "#A9A7FB");
                d3.select(this.closest('svg'))
                    .select('.tooltip').style('display', 'none');
                d3.select(this.closest('svg'))
                    .select(".tooltip").remove();
                d3.select(this)//.selectAll('path')
                    .style("opacity", 1);
                d3.select('#dotFocus').remove();
            });

        //Left Y Axis legend
        svg.append('text')
            .attr('x', -(height / 2))
            //.attr('y', (margin.left / 3))
            .attr('y', 10)
            .attr("dy", "1em")
            .attr("font-family", "Graphik Regular")
            .attr('transform', 'rotate(-90)')
            .style('fill', '#015b63')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .text(this.viewData[0].XAxis == "TicketCount" ? "TicketAge (In days)" : "TicketCount");

        //Right Y Axis legend
        svg.append('text')
            .attr('x', -(height / 2))
            .attr('y', svgWidth - 10)
            //.attr("dy", "1em")
            .attr("font-family", "Graphik Regular")
            .attr('transform', 'rotate(-90)')
            .style('fill', '#015b63')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'middle')
            .style('font-weight', 'bold')
            .text(this.viewData[0].XAxis == "TicketCount" ? "TicketCount" : "TicketAge (In days)");

        //X Axis legend
        var columnChart = svg.append("g")
            .attr("transform",
                "translate(" + (-margin.left) + "," + 0 + ")");

        columnChart.append("rect")
            .attr("x", (svgWidth / 2) - 20)
            .attr("y", svgHeight - margin.top - 10)
            .attr('height', 12)
            .attr('width', 12)
            .attr('rx', 8)
            .attr('ry', 8)
            .style('fill', '#41B6FF')
            .style('cursor', 'default')
            .style('top', margin.top)
            .attr('text-anchor', 'end');

        columnChart.append('text')
            .attr('x', (svgWidth / 2))
            .attr('y', svgHeight - margin.top)
            .style('fill', '#015b63')
            .style('cursor', 'pointer')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'start')
            .text(this.viewData[0].XAxis == "TicketCount" ? "TicketAge" : "#Tickets");

        var lineChart = svg.append("g")
            .attr("transform",
                "translate(" + (margin.right) + "," + 0 + ")");

        lineChart.append("line")
            .attr("x1", (svgWidth / 2) - 25)
            .attr("y1", svgHeight - margin.top - 5)
            .attr("x2", (svgWidth / 2) - 7)
            .attr("y2", svgHeight - margin.top - 5)
            .attr("fill", "none")
            .attr("opacity", "0.7")
            .attr("stroke", "#02209A")
            .attr("stroke-width", 2);

        lineChart.append("rect")
            //.attr("transform", "translate(" + ((svgWidth / 2) - 15) + ", " + (svgHeight - margin.top - 5) + ")")
            .attr("x", (svgWidth / 2) - 20)
            .attr("y", svgHeight - margin.top - 9)
            .attr('height', 8)
            .attr('width', 8)
            .attr('rx', 4)
            .attr('ry', 4)
            .style('fill', '#02209A')
            .attr("opacity", "0.7")
            .style('cursor', 'default')
            .style('top', margin.top)
            .attr('text-anchor', 'end');

        lineChart.append('text')
            .attr('x', (svgWidth / 2))
            .attr('y', svgHeight - margin.top)
            .style('fill', '#015b63')
            .style('cursor', 'pointer')
            .style('font-size', '12px')
            .style('font-weight', 'bold')
            .attr('text-anchor', 'start')
            .text(this.viewData[0].XAxis == "TicketCount" ? "#Tickets" : "TicketAge");
        if (this.totalPage > 1) {
            //Pagination
            svg.append("path")
                .attr("d", "M3.875,3.095,6.8.163a.551.551,0,0,1,.782,0,.558.558,0,0,1,0,.784L4.267,4.269a.553.553,0,0,1-.763.016L.161.949A.554.554,0,0,1,.943.165Z")
                .attr('transform', "translate(" + margin.left + ", " + (svgHeight - margin.bottom + 9) + ") rotate(90)")     //19 (Because tickpadding=8 + margin from insertLineBreak=10 + 1(MagicNumber))
                .attr('class', 'leftTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .attr('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentPage != 1) {
                        that.currentPage--;
                        that.prevPage();
                    }
                })
            svg.append("path")
                .attr("d", "M3.875,1.335,6.8,4.267a.551.551,0,0,0,.782,0,.558.558,0,0,0,0-.784L4.267.161A.553.553,0,0,0,3.5.145L.161,3.481a.554.554,0,0,0,.782.784Z")
                .attr('transform', "translate(" + (svgWidth - margin.right + 20) + ", " + (svgHeight - margin.bottom + 9) + ") rotate(90)")
                .attr('class', 'rightTriangle')
                .attr('fill', '#000')
                .attr('stroke', '#000')
                .attr('stroke-width', 2)
                .attr("opacity", 0.7)
                .style('cursor', 'pointer')
                .on('click', function (d) {
                    if (that.currentPage < that.totalPage) {
                        that.currentPage++;
                        that.nextPage();
                    }
                })

            if (that.currentPage == 1) {
                svg.select(".leftTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
            if (that.currentPage == that.totalPage) {
                svg.select(".rightTriangle").attr('fill', '#cccccc').attr('stroke', '#cccccc').attr('stroke-width', 2).attr("opacity", 0.7).style('cursor', 'default');
            }
        }
    }
    /*generic way */
    nextPage() {
        //this.viewData = this.GraphData.chartData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
        this.LoadComboChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }

    prevPage() {
        //this.viewData = this.GraphData.chartData.slice((this.currentPage - 1) * this.barnumber, this.currentPage * this.barnumber);
        this.LoadComboChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.LoadComboChart(this.GraphData.chartData, this.GraphData.chartContainerName);
    }
    GenerateTicks(axisRange, maxData) {
        let tickArray = axisRange.ticks(4);
        if (tickArray[tickArray.length - 1] < maxData) {
            let diff = (tickArray[tickArray.length - 1]) - (tickArray[tickArray.length - 2]); // Add the difference to create new tick
            tickArray.push(tickArray[tickArray.length - 1] + diff);
        }
        return tickArray;
    }
    isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    CleanNumber(str) {
        if (str != 0)
            str = str.toFixed(2);
        if (str >= 1)
            str = d3.format("~s")(str);
        else
            str = str;
        if (!this.isNumeric(str)) {
            let lastLetter = str.substring(str.length - 1);
            str = str.substring(0, str.length - 1);
            if (str.indexOf('.'))
                str = parseFloat(str).toFixed(1).toString() + lastLetter;
        }
        return str;
    }
}
